import { useEffect } from 'react'; // Ajuste o caminho conforme necessário
import { useAuth } from '../context/authContext';
import LOGO from '../assets/profile.jpg'
import { useWebSocket } from '../services/useWebSocket';

const useCommentWebSocket = () => {
    const { user, authenticated } = useAuth();
    const { connectWebSocket, isConnect, stompClient } = useWebSocket();

    useEffect(() => {
        connectWebSocket();

        return () => {
            if (stompClient && !isConnect) {
                stompClient.disconnect();
            }
        };
    }, []);

useEffect(() => {
    const originalTitle = document.title;

    if (authenticated) {
        if (isConnect && stompClient) {
            const subscription = stompClient.subscribe(`/comment/user/${user.sub}`, (message) => {
                const newComment = JSON.parse(message.body);

                const lastCommentId = localStorage.getItem("lastCommentId");

                if (!lastCommentId || lastCommentId.toString() !== newComment.id.toString()) {
                    localStorage.setItem("lastCommentId", newComment.id);

                    if (newComment.userEmail !== user.sub) {
                        // Altera o título da aba com (1)
                        document.title = `(1) ${originalTitle}`;

                        // Exibe notificação do navegador
                        if (Notification.permission === "granted") {
                            const notification = new Notification(
                                `${newComment.userName} enviou uma mensagem para você:`,
                                {
                                    body: newComment.comment,
                                    icon: LOGO
                                }
                            );

                            notification.onclick = function () {
                                window.focus();
                                window.location.href = "/minhas-solicitacoes/ticket/" + newComment.calledTicket;
                            };
                        }
                    }
                }
            });

            // Limpa a assinatura ao desmontar o componente
            return () => {
                subscription.unsubscribe();
            };
        }
    }

    // Restaura o título ao focar na aba novamente
    const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
            document.title = originalTitle;
        }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup
    return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        document.title = originalTitle; // garante restauração ao desmontar
    };
}, [stompClient, isConnect]);


};

export default useCommentWebSocket;
